<template>
  <!-- Card inicial -->
  <v-card
    v-if="!showChat"
    outlined
    class="mx-auto mr-2"
    max-width="660"
    height="14vh"
    @click="toggleChat(true)"
  >
    <v-layout center class="h-2 ml-2 mt-2">
      <div id="font" class="primary--text">Assistente</div>
      <div id="font" class="orange--text">IA</div>
    </v-layout>

    <v-card-text class="text-justify pa-4">
      <p>Olá, Dr(a) <strong>{{ user.nome }}</strong>!</p>

      <p class="text-caption primary--text mt-2">Clique aqui para começar a conversar</p>
    </v-card-text>
  </v-card>

  <!-- Card com chat -->
  <v-card v-else max-width="560" flat>
    <v-toolbar elevation="1" dense class="mb-1 mr-1">
      <v-layout center row class="mt-1">
        <div id="font">Simples</div>
        <div id="font" class="primary--text">Assistente</div>
        <div id="font" class="orange--text">IA</div>
      </v-layout>
      <v-spacer />
      <v-btn color="red" icon @click="toggleChat(false)">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- Chat -->
    <deep-chat
      ref="deepChatRef"
      :chat="{
        system_prompt: promptFinal,
        model: 'gpt-4o',
        temperature: 0.7,
        max_tokens: 1000
      }"
      directConnection='{
        "openAI": {
          "key": "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"
        }
      }'
      connect='{"stream": true}'
      style="height: 70vh; width: 100%; max-width: 900px; border-radius: 10px"
      class="mx-auto mr-2"
      avatars='{
        "default": {"styles": {"position": "left"}},
        "ai": {"src": "path-to-icon.png"}
      }'
      messageStyles='{
        "default": {
          "shared": {
            "bubble": {
              "maxWidth": "100%", "backgroundColor": "unset", "marginTop": "10px", "marginBottom": "10px"
            }
          },
          "user": {
            "bubble": {
              "marginLeft": "0px", "color": "white", "backgroundColor": "#00BCD4"
            }
          },
          "ai": {
            "outerContainer": {
              "backgroundColor": "rgba(247,247,248)", "borderTop": "1px solid rgba(0,0,0,.1)", "borderBottom": "1px solid rgba(0,0,0,.1)"
            }
          }
        }
      }'
      submitButtonStyles='{
        "submit": {
          "container": {
            "default": {"backgroundColor": "#00BCD4"},
            "hover": {"backgroundColor": "#00a2bb"},
            "click": {"backgroundColor": "#008b9c"}
          },
          "svg": {
            "content": "<?xml version=\\"1.0\\" ?><svg viewBox=\\"0 0 24 24\\" xmlns=\\"http://www.w3.org/2000/svg\\"><g><path d=\\"M21.66,12a2,2,0,0,1-1.14,1.81L5.87,20.75A2.08,2.08,0,0,1,5,21a2,2,0,0,1-1.82-2.82L5.46,13H11a1,1,0,0,0,0-2H5.46L3.18,5.87A2,2,0,0,1,5.86,3.25h0l14.65,6.94A2,2,0,0,1,21.66,12Z\\"></path></g></svg>",
            "styles": {
              "default": {
                "width": "1.3em",
                "marginTop": "0.15em",
                "filter": "brightness(0) saturate(100%) invert(100%) sepia(28%) saturate(2%) hue-rotate(169deg) brightness(107%) contrast(100%)"
              }
            }
          }
        }
      }'
      textInput='{
        "placeholder": {
          "text": " Digite sua mensagem aqui...",
        },
        "styles": {
          "container": {
            "backgroundColor": "#f5f9ff",
            "maxHeight": "55px"
          },
          "text": {
            "color": "#263238"
          },
          "focus": {
            "border": "2px solid #00BCD4"
          }
        }
      }'
    >
      <!-- Header personalizado -->
      <div
        style="
          width: 100%;
          max-width: 360px;
          padding: 16px;
          font-family: 'Roboto', sans-serif;
          text-align: center;
          margin-bottom: -12px;
        "
      >
        <v-icon color="#00BCD4" style="vertical-align: middle;">mdi-stethoscope</v-icon>
        <span
          style="font-size: 18px; font-weight: 600; color: #00BCD4; margin-left: 8px; vertical-align: middle;"
        >
          Simples Assistente IA
        </span>
        <div
          style="margin-top: 10px; font-size: 14px; font-style: italic; color: #607d8b;"
        >
          Olá, Dr(a). <strong>{{ user.nome }}</strong>! Como posso ajudar?
        </div>
      </div>
    </deep-chat>
  </v-card>
</template>

<script>
export default {
  props: {
    system_prompt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showChat: false,
      user: null
    }
  },
  computed: {
    promptFinal () {
      return `Você é um assistente médico especializado. Forneça respostas precisas e baseadas em evidências.`
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
  },
  methods: {
    removeHtmlTags (str) {
      if ((str === null) || (str === '')) { return false } else { str = str.toString() }
      return str.replace(/<[^>]*>/g, '')
    },
    toggleChat (val) {
      this.showChat = val
      this.$emit('showChat', val)
      console.log(`Chat toggled: ${val}`)

      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            const deepChat = this.$refs.deepChatRef
            if (deepChat && typeof deepChat.submitUserMessage === 'function') {
              deepChat.submitUserMessage({
                role: 'system',
                text: 'Dados do paciente carregados. Não gere saída:' + '[' + this.removeHtmlTags(this.system_prompt) + ']'
              })
              // deepChat.clearMessages()
            } else {
              console.warn('deep-chat ainda não está pronto.')
            }
          }, 400)
        })
      }
    }
  }
}
</script>
